module.exports = __webpack_public_path__ + "static/media/Alpha-iQ-OA-6600-iQ.df648901.png";